<template>
	<div>
		<div style="text-align: left; padding-bottom: 10px;">
			<el-row :gutter="2">
					<el-col :span="6">
						<el-input v-model="companyName" class="" placeholder="公司名称"></el-input>
					</el-col>
					<el-col :span="6">
						<el-input v-model="city" class="" placeholder="站点城市"></el-input>
					</el-col>
					<el-col :span="12">
						<el-button type="primary" @click="searchCity">查询</el-button>
					</el-col>
				</el-row>
		</div>
		<div>
		<el-table :data="tableData" style="width: 100%" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
			<el-table-column prop="companyName" label="公司名称" width="180"></el-table-column>
      		<el-table-column prop="targetCity" label="目的地" width="180"></el-table-column>
      		<el-table-column prop="isTransit" label="是否中转" width="180">
      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.isTransit==0" >否</el-tag>
      				<el-tag v-if="scope.row.isTransit==1" >是</el-tag>
      			</template>
      		</el-table-column>
      		<el-table-column label="状态" width="180">
      			<template slot-scope="scope">
      				<el-tag v-if="scope.row.state==0" type="danger">无效</el-tag>
      				<el-tag v-if="scope.row.state==1" type="success">有效</el-tag>
      			</template>
      		</el-table-column>
      		<el-table-column prop="createTime" label="添加时间" width="160"></el-table-column>
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" v-if="scope.row.state==0" @click="cityToVisiable(scope.$index, scope.row)">置为有效</el-button>
					<el-button size="small" v-if="scope.row.state==1" @click="cityToVisiable(scope.$index, scope.row)">置为失效</el-button>
					<el-button size="small" @click="cityUpdate(scope.$index, scope.row)">修改</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" :current-page="currentPage" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		</div>	
	</div>

	
</template>
<script >
	import {getAllCityList,updateCityState} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		pageSize:15,
		 		total:0,
		 		pageCount:0,
		 		currentPage:0,
		 		lineId:"",
		 		city:"",
		 		companyName:""
		 	}
		},
		created:function() {
			var _this = this;
			var lineId = this.$route.query.lineId;
			this.lineId = lineId;
			console.log(lineId);
			let params = {pageNum:0,pageSize:this.pageSize,lineId:lineId};
			this.lineId = lineId;
			getAllCityList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
				this.currentPage = res.data.data.pageNum;
			});
			
		},
		methods:{
			searchCity(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize,lineId:this.lineId,city:this.city,companyName:this.companyName};
				getAllCityList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			reload(){
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,lineId:this.lineId,city:this.city,companyName:this.companyName};
				getAllCityList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			
			cityUpdate(index,row){
				this.$router.push({name:"addCity",query:{id:row.id}});
			},
			addCity(){
				this.$router.push({name:"addCity",query:{lineId:this.lineId}});
			},
			cityToVisiable(index,row){
				let _this = this;
				let params={id:row.id};
				if(row.state==1){
					params.state=0;
				}else{
					params.state=1;
				}
				updateCityState(params).then(res=>{
					if(res.data.status=='success'){
						this.$message({
					            type: 'success',
					            message: '操作成功'
					         });
						_this.reload();
					}
				});
			}
		}
	}
</script>